export const displayPlainText = (text: string) => {
  // Some components offer to input plain text: e.g. titles of clickable tabs.
  return text;
};
